import { Box, Divider, Typography } from "@mui/material"
import type { FC } from "react"

import type { SalesProduct } from "../../../types"

interface PackagingDisplayProps {
  product: SalesProduct
}

const formatWeight = (weight?: number | null, uomName?: string | null): string => {
  if (weight === null || weight === undefined) return ""
  return `${weight} ${uomName ?? ""}`.trim()
}

export const PackagingDisplay: FC<PackagingDisplayProps> = ({ product }) => {
  const {
    packageUsWeight,
    packageUsWeightUomDetails,
    packageMetricWeight,
    packageMetricWeightUomDetails,
    palletUsWeight,
    palletUsWeightUomDetails,
    palletMetricWeight,
    palletMetricWeightUomDetails,
  } = product

  const usWeight = formatWeight(packageUsWeight, packageUsWeightUomDetails?.name)
  const metricWeight = formatWeight(packageMetricWeight, packageMetricWeightUomDetails?.name)
  const stdUom = [usWeight, metricWeight].filter(Boolean).join(" / ")
  const palletUsWeightLabel = formatWeight(palletUsWeight, palletUsWeightUomDetails?.name)
  const palletMetricWeightLabel = formatWeight(palletMetricWeight, palletMetricWeightUomDetails?.name)
  const uomPerPallet = [palletUsWeightLabel, palletMetricWeightLabel].filter(Boolean).join(" / ")

  if (!stdUom && !uomPerPallet) return null

  return (
    <Box className='flex flex-col gap-3'>
      <Typography className='text-ml font-normal leading-[150%] tracking-[0.15px] text-gray-900'>Packaging</Typography>
      {stdUom && (
        <Box className='flex items-center justify-between'>
          <Typography className='text-sm font-normal leading-[125%] text-gray-900'>Std. UoM</Typography>
          <Typography className='text-sm font-normal leading-[125%] text-gray-900'>{stdUom}</Typography>
        </Box>
      )}
      {stdUom && uomPerPallet && <Divider />}
      {uomPerPallet && (
        <Box className='flex items-center justify-between'>
          <Typography className='text-sm font-normal leading-[125%] text-gray-900'>UoM per Pallet (lb/kg)</Typography>
          <Typography className='text-sm font-normal leading-[125%] text-gray-900'>{uomPerPallet}</Typography>
        </Box>
      )}
    </Box>
  )
}
